(function(global) {
    'use strict';
  
    var lib = global.lib || (global.lib = {}),
        mms = global.mms || (global.mms = {}),
        cjs = global.createjs || (global.createjs = {});
    
    function Zoom() {
        this.__parent__.apply(this, arguments);
        
        this.visible = false;
        
        this.on("added", this._added, this);
    }
    Zoom.prototype = {
        _added: function() {
            this.bounds = this.getBounds();

            if (!this.painting) {
                this.painting = this.parent.parent.painting;
                
                mms.state.signals.changeZoom.add(this._changeZoom, this);
                mms.state.signals.changeZoomPos.add(this._changeZoomPos, this);

                if (!this.maskMc) {
                    this.maskMc = new lib.ZoomMask();
                    this.hitArea = this.maskMc;
                }

                this.offsets = {};
                this.on("mousedown", this._mousedown, this);
                this.on("pressup", this._pressup, this);
                this.on("pressmove", this._pressmove, this);
            }
        },
        _changeZoom: function(value) {
            if (this.painting === mms.state.painting && value) {
                this.visible = true;
                this._updatePos(mms.state.zoomPos[this.painting]);
                mms.state.setTweening(mms.State.TWEEN_ZOOM);
                this.mask.scaleX = 0;
                this.mask.scaleY = 0;
                this.alpha = 1;
                TweenLite.to(this.mask, 1, {scaleX: 1, scaleY: 1, ease: Expo.easeOut, onComplete: function() {
                    mms.state.setTweening('');
                }});
            }
            else if (this.visible) {
                mms.state.setTweening(mms.State.TWEEN_ZOOM);
                var self = this;
                TweenLite.to(this, 1, {alpha: 0, ease: Sine.easeOut, onComplete: function() {
                    self.visible = false;
                    mms.state.setTweening('');
                }});
            }
        },
        _changeZoomPos: function(painting, prevValue) {
            if (this.parent && this.painting === painting) {
                this._updatePos(mms.state.zoomPos[painting]);
            }
        },
        _updatePos: function(pos) {
            var zoomRect = mms.state.zoomRect[this.painting],
                x = (pos.x / zoomRect.width) * (this.bounds.width - zoomRect.width),
                y = (pos.y / zoomRect.height) * (this.bounds.height - zoomRect.height);
            this.mask.x = zoomRect.x + pos.x;
            this.mask.y = zoomRect.y + pos.y;
            this.x = zoomRect.x - x + this.regX;
            this.y = zoomRect.y - y + this.regY;
            this.maskMc.x = (pos.x / zoomRect.width) * this.bounds.width;
            this.maskMc.y = (pos.y / zoomRect.height) * this.bounds.height;
        },
        _mousedown: function(evt) {
            this.offsets[evt.pointerID] = {
                x: evt.stageX - this.mask.x,
                y: evt.stageY - this.mask.y
            };
        },
        _pressup: function(evt) {
            delete this.offsets[evt.pointerID];
        },
        _pressmove: function(evt) {
            var offsets = _.values(this.offsets);
            if (offsets.length === 1) {
                var zoomRect = mms.state.zoomRect[this.painting],
                    newPos = {
                        x: Math.max(0, Math.min(zoomRect.width, evt.stageX - zoomRect.x - offsets[0].x)),
                        y: Math.max(0, Math.min(zoomRect.height, evt.stageY - zoomRect.y - offsets[0].y))
                    };
                mms.state.setZoomPos(this.painting, newPos);
            }
        }
    };
    
    function ZoomOverlay() {
        this.__parent__.apply(this, arguments);
        
        this.alpha = 0;

        this.on("added", this._added, this);
    }
    ZoomOverlay.prototype = {
        _added: function() {
            if (!this.painting) {
                // todo: quick hack: matrixCache 
                this.matrixCache = this.getMatrix();
                this.painting = this.parent.parent.painting;
                mms.state.signals.changeZoom.add(this._changeZoom, this);
                mms.state.signals.changeZoomPos.add(this._changeZoomPos, this);
            }
        },
        _changeZoom: function() {
            if (this.painting === mms.state.painting) {
                var alpha = mms.state.zoom ? 1 : 0,
                    ease = mms.state.zoom ? Sine.easeOut : Linear.easeNone,
                    delay = mms.state.zoom ? 0.5 : 0;
                TweenLite.killTweensOf(this);
                TweenLite.to(this, 1, {alpha: alpha, ease: ease, delay: delay});
                this._updateMask();
            }
        },
        _changeZoomPos: function() {
            if (this.painting === mms.state.painting) {
                this._updateMask();
            }
        },
        _updateMask: function() {
            var zoomRect = mms.state.zoomRect[this.painting],
                zoomPos = mms.state.zoomPos[this.painting],
                shape = new cjs.Shape();
            shape.graphics.beginFill("#ff0000");
            // todo: get rid of the constants and matrixCache
            var width = 1080,
                height = 1920,
                radius = 500;
            shape.graphics.drawRect(0, 0, width, height);
            shape.graphics.arc(zoomRect.x + zoomPos.x - this.matrixCache.tx,  zoomRect.y + zoomPos.y - this.matrixCache.ty, radius, 0, Math.PI * 2, true).closePath();
            shape.x += this.matrixCache.tx;
            shape.y += this.matrixCache.ty;
            this.mask = shape;
        }
    };
    
    lib.Zoom1a = cjs.extend2(lib.Zoom1a, Zoom);
    lib.Zoom1b = cjs.extend2(lib.Zoom1b, Zoom);
    lib.Zoom2 = cjs.extend2(lib.Zoom2, Zoom);
    lib.Zoom3a = cjs.extend2(lib.Zoom3a, Zoom);
    lib.Zoom3b = cjs.extend2(lib.Zoom3b, Zoom);
    
    lib.ZoomOverlay = cjs.extend2(lib.ZoomOverlay, ZoomOverlay);
    
    mms.Zoom = Zoom;
  
})(this);